export const ADVERTISEMENT = 'containerItems.advertisement';
export const LEARN_MORE = 'video.ads.learn.more';
export const WHY_ADS = 'video.ads.why.ads';
export const ADS_WILL_FINISH_COUNTDOWN = 'video.ads.will.finish.countdown';
